import { useEffect } from 'react'

interface useDynamicFilterProps {
  /**
   * An array of all rows that we can filter
   */
  allRows: Array<any> | false

  /**
   * Function that sets the rows that are already filtered (filtering from allRows data source)
   */
  setFilteredRows: Function

  /**
   * Current form input value of the field
   */
  inputValue: any

  /**
   * Property name that we filter by from the allRows data source
   */
  filterColumnName: string

  /**
   * useForm function that sets the value of the field
   */
  setDefaultFormFieldValue: Function

  /**
   * Propery name of the dynamic field in the form
   */
  formFieldValueName: string

  /**
   * if true, then the current selected value is extracted from an object, from its identityColumnName attribute
   */
  isFormFieldValueNameObject?: boolean

  /**
   * Object that contains current values for all form fields
   */
  currentFormValues: any

  /**
   * Property name for the dynamic field in allRows data source (typically `id` as the primary key)
   */
  identityColumnName: string

  /**
   * If true, then the hook sets the first record in filtered list as the default value
   */
  setFirstRecordAsDefault?: boolean
}

const useDynamicFilter = (props: useDynamicFilterProps) => {
  useEffect(() => {
    if (props.allRows instanceof Array) {
      let currFormFieldValue: any = props.currentFormValues[props.formFieldValueName] || null

      if (currFormFieldValue !== null && props.isFormFieldValueNameObject) {
        currFormFieldValue = currFormFieldValue?.hasOwnProperty(props.identityColumnName)
          ? currFormFieldValue[props.identityColumnName]
          : null
      }
      const isInputEmpty: boolean = [undefined, '', null].includes(props.inputValue)

      const filteredRows = isInputEmpty
        ? props.allRows
        : props.allRows.filter((obj) => {
            return obj[props.filterColumnName]?.toString() === props.inputValue?.toString()
          })
      const isPreservedInArray = filteredRows.some(
        (obj) => currFormFieldValue?.toString() === obj[props.identityColumnName]?.toString(),
      )

      if (!isInputEmpty && !isPreservedInArray) {
        props.setDefaultFormFieldValue(props.formFieldValueName, '')
      }

      if (props.setFirstRecordAsDefault === true) {
        props.setDefaultFormFieldValue(props.formFieldValueName, filteredRows[0] ?? '')
      }

      props.setFilteredRows(filteredRows)
    }
  }, [props.inputValue])
}

export default useDynamicFilter
